// Module 2 / Slice 9 — reference admin code-set index screen.
// Mirrors UsersScreen / RolesScreen idiom: read-first list, drawer-style
// edit lands in a follow-up. Plan §10 screen 1.

import { useQuery } from "@tanstack/react-query";
import { referenceApiClient } from "../../api/client";
import { useI18n } from "../../i18n/I18nContext";
import { Link } from "@tanstack/react-router";

export function CodeSetIndexScreen(): JSX.Element {
  const { t } = useI18n();
  const query = useQuery({
    queryKey: ["reference", "code-sets"],
    queryFn: async () => {
      const response = await referenceApiClient.GET("/reference/code-sets", {
        params: { query: { limit: 200, includeArchived: false } },
      });
      if (!response.data) {
        throw new Error("reference_codesets_fetch_failed");
      }
      return response.data;
    },
  });

  return (
    <div>
      <h1>{t("reference.codesets.heading")}</h1>
      <p className="rc-help">{t("reference.codesets.description")}</p>
      {query.isLoading && <p>{t("login.discovering")}</p>}
      {query.isError && (
        <p role="alert" style={{ color: "var(--rc-color-danger)" }}>
          {(query.error as Error).message}
        </p>
      )}
      {query.data && query.data.items && query.data.items.length === 0 && (
        <p>{t("reference.codesets.empty")}</p>
      )}
      {query.data && query.data.items && query.data.items.length > 0 && (
        <table className="rc-table">
          <thead>
            <tr>
              <th>{t("reference.codesets.column.key")}</th>
              <th>{t("reference.codesets.column.displayName")}</th>
              <th>{t("reference.codesets.column.codeCount")}</th>
              <th>{t("reference.codesets.column.active")}</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {query.data.items.map((cs) => (
              <tr key={cs.id} data-testid={`codeset-row-${cs.key}`}>
                <td><code>{cs.key}</code></td>
                <td>{cs.displayName}</td>
                <td>{cs.codeCount}</td>
                <td>{cs.isActive ? "\u2714" : "\u2014"}</td>
                <td>
                  <Link to="/admin/reference/code-sets/$codeSetId/codes" params={{ codeSetId: cs.id }}>
                    {t("reference.codesets.action.viewCodes")}
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
